import React from "react";


const TopBannerOne = ({ inPlaySlidingBanners, }) => {

  return (
    <div
      title="InPlayAndPopulars"
      id="banners"
      className=" w-full px-[6px] rounded-md overflow-hidden"
      style={{ aspectRatio: 2.00561 / 1, maxHeight: "350px" }}
    >
      <div className="w-full relative h-full z-10 rounded-md overflow-hidden">
        <img
          src={inPlaySlidingBanners[0]?.image}
          className={`min-w-full min-h-full absolute top-0 left-0 transition-transform duration-500 ease-in-out  'translate-x-0'`}
          alt={`Carousel Image 0`}
          loading="lazy"
        />
      </div>
    </div>
  );
}


export default TopBannerOne;
